'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Button, Icon, Input, Row, Typography } from '@repo/ui/components'
import { useState, type ReactNode } from 'react'
import { useFiltersStore } from '@repo/shared/store'
import { useIsDesktop } from '@repo/ui/hooks'
import { XIcon } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'
export type ProjectsCTAProps = {
  children: ReactNode
}

export const ProjectsCTA = ({ origin }: { origin: 'layout' | 'container' }) => {
  const { t } = useTranslate()
  const { setFilters } = useFiltersStore()
  const filters = useFiltersStore((state) => state.filters)
  const isDesktop = useIsDesktop()
  const [showSearch, setShowSearch] = useState(false)
  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0 bg-neutral-surface-light' : ''}  justify-between h-fit gap-md p-md `}
    >
      <Typography size='md' weight='bold'>
        {t('projectsPage_title')}
      </Typography>

      {!isDesktop && origin === 'layout' && (
        <AnimatePresence mode='wait'>
          {showSearch ? (
            <motion.div
              key='search-input'
              className='w-full'
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
            >
              <Row className='gap-xs'>
                <Button
                  variant='transparent'
                  size='md'
                  color='neutral'
                  onClick={() => setShowSearch(false)}
                >
                  <XIcon className='size-5' />
                </Button>
                <Input
                  value={filters.search}
                  onChange={(e) =>
                    setFilters({ ...filters, search: e.target.value })
                  }
                  autoComplete='off'
                  placeholder={t('common_search')}
                  icon={
                    <Icon
                      name='SearchLine'
                      size='sm'
                      color='fill-neutral-surface-40'
                    />
                  }
                  endIcon={
                    filters.search && (
                      <Icon
                        name='XmarkCircle'
                        size='sm'
                        color='fill-neutral-surface-40'
                        onClick={() => setFilters({ ...filters, search: '' })}
                      />
                    )
                  }
                  inputSize='sm'
                  autoFocus
                  className='w-full '
                />
              </Row>
            </motion.div>
          ) : (
            <motion.div
              key='search-button'
              initial={{ opacity: 0, x: 0 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
            >
              <Button
                variant='transparent'
                size='md'
                color='neutral'
                onClick={() => setShowSearch(true)}
              >
                <Icon
                  name='SearchLine'
                  size='sm'
                  color='fill-neutral-surface-40'
                />
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </Row>
  )
}
